export default __webpack_public_path__ + "static/media/FullShieldCrop.a8ae1eda.png";